<template>
  <PlainTable :sourceList="itemArray" :useExcel="true" ref="contentTable">
    <template #header>
      <caption>
        <span class="blind">평균점수 누적통계(최근 6개월,조회기간 무관)</span>
      </caption>
      <colgroup>
      </colgroup>
      <thead class="table_list_head table_list_head_line">
        <tr>
          <!-- <th>20미만</th> -->
          <th>20점 이상</th>
          <th>40점 이상</th>
          <th>60점 이상</th>
          <th>80점 이상</th>
        </tr>
      </thead>
    </template>
    <template #row="{rowData}">
      <tr>
        <td>{{rowData.score20}}</td>
        <td>{{rowData.score40}}</td>
        <td>{{rowData.score60}}</td>
        <td>{{rowData.score80}}</td>
      </tr>
    </template>
  </PlainTable>
</template>

<script>
export default {
  props: {
    itemArray: Array
  }
};
</script>
